import { IManager as ISharedManager } from '@shared/interfaces/IManager';
import { IManager } from '../interfaces';
import { getTradeTranslation } from './translations.utils';

export const getManagerDisplayText = (manager: IManager | ISharedManager): string => {
	const tradeTranslation: string = getTradeTranslation(manager);
	return `${manager.name} ${tradeTranslation !== '' ? `- ${tradeTranslation}` : ''}`;
};
